import React, { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

export const Toast = ({ id, type = 'info', message, duration = 3000, onClose }) => {
    useEffect(() => {
        if (duration) {
            const timer = setTimeout(() => {
                onClose(id);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [id, duration, onClose]);

    const icons = {
        success: <CheckCircle size={20} className="text-green-500" />,
        error: <AlertCircle size={20} className="text-red-500" />,
        warning: <AlertTriangle size={20} className="text-yellow-500" />,
        info: <Info size={20} className="text-blue-500" />
    };

    const bgColors = {
        success: 'bg-stone-900 border-green-900/50',
        error: 'bg-stone-900 border-red-900/50',
        warning: 'bg-stone-900 border-yellow-900/50',
        info: 'bg-stone-900 border-blue-900/50'
    };

    return (
        <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-xl min-w-[300px] animate-in slide-in-from-right-full duration-300 ${bgColors[type] || bgColors.info}`}>
            {icons[type] || icons.info}
            <p className="text-stone-200 text-sm font-medium flex-1">{message}</p>
            <button onClick={() => onClose(id)} className="text-stone-500 hover:text-stone-300 transition-colors">
                <X size={16} />
            </button>
        </div>
    );
};
